import { useSelector } from 'react-redux';
import { isCheckout } from '../utils/wp';

export function useStep() {
    return useSelector(state => {
        if (isCheckout()) {
            return 3;
        }

        const tickets = state.cart.confirmed_tickets;

        const foodTicket = state.cart.food_ticket;
        const food = state.cart.confirmed_food;

        if (
            !tickets.length ||
            (foodTicket && !food)
        ) {
            return 1;
        }

        return 2;
    });
}
